<template>
    <Card>
        <div class="card card-body bg-hover-light-primary mb-2 py-5" v-for="store in stores">
            <div class="row my-2">
                <div class="col-4">
                    <h3 class="m-0 text-truncate">{{ store.name }}</h3>
                    <span class="text-muted">{{ store.uuid }}</span>
                    <div class="mt-2 font-weight-bold d-none">
                        Merchant-ID: {{ store.gmb_merchant_id ? store.gmb_merchant_id : '-' }}<br>
                        Store Code: {{ store.gmb_store_code ? store.gmb_store_code : '-' }}
                    </div>
                    <div class="mt-4" v-if="store.logo">
                        <img class="h-3em" :src="store.logo" :alt="store.name">
                    </div>
                </div>
                <div class="col-4">
                    <apexchart v-if="store.google_inventory_series && store.google_inventory_series.length > 0"
                               type="area" height="140" :series="formatSeries(store.google_inventory_series)"
                               :options="formatOptions('Inventory Exportiert', store.google_inventory_series)"></apexchart>
                    <div v-else style="line-height: 160px;" class="text-center text-muted">
                        Keine Einträge vorhanden
                    </div>
                </div>
                <div class="col-4">
                    <apexchart v-if="store.google_primary_series && store.google_primary_series.length > 0" type="area"
                               height="140" :series="formatSeries(store.google_primary_series)"
                               :options="formatOptions('Primary Exportiert', store.google_primary_series)"></apexchart>
                    <div v-else style="line-height: 160px;" class="text-center text-muted">
                        Keine Einträge vorhanden
                    </div>
                </div>
            </div>
        </div>
    </Card>
</template>

<script>
import Card from '@components/Cards/Card.vue'

export default {
    components: {
        Card,
    },

    props: {
        stores: Array,
    },

    methods: {
        formatSeries(series) {
            return [
                {
                    name: 'Artikel',
                    data: this.arrayColumn(series, 'value'),
                },
            ]
        },

        formatOptions(title, series) {
            return {
                chart: {
                    type: 'area',
                    height: 140,
                    zoom: {
                        enabled: false,
                    },
                },
                colors: ['#9881F6'],
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: 'straight',
                },
                title: {
                    text: title,
                    align: 'left',
                },
                labels: this.arrayColumn(series, 'timestamp'),
                xaxis: {
                    type: 'datetime',
                },
                yaxis: {
                    opposite: true,
                    type: 'numeric',
                },
                legend: {
                    horizontalAlign: 'left',
                },
            }
        },

        arrayColumn(array, column) {
            return array.map(item => item[column])
        },
    },
}
</script>
